module.exports = __webpack_public_path__ + "images/sprites/ui/icon_tag_pin_wh_050cf07eecb4653de0bc10caaf73e0c0.png";